var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2671 5.76001L6.60217 1.5296C6.17967 1.0421 5.40509 1.04426 4.91434 1.5361L1.9005 4.55535C1.0035 5.45343 0.746752 6.78701 1.26567 7.85626C4.36576 14.275 9.54239 19.4589 15.9568 22.5679C17.0249 23.0868 18.3574 22.8301 19.2544 21.932L22.2964 18.8846C22.7893 18.3917 22.7904 17.6128 22.2986 17.1903L18.0519 13.5448C17.6078 13.1635 16.9177 13.2133 16.4724 13.6597L14.9948 15.1395C14.9191 15.2188 14.8195 15.2711 14.7113 15.2883C14.6031 15.3055 14.4922 15.2867 14.3957 15.2348C11.9803 13.844 9.97674 11.8378 8.589 9.4206C8.53703 9.32391 8.51821 9.21284 8.53543 9.10443C8.55265 8.99602 8.60496 8.89625 8.68434 8.82043L10.1577 7.34601C10.604 6.89751 10.6528 6.20418 10.2671 5.75893V5.76001Z",
    stroke: "#09321C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.d2ca7e259cf9b6a2d524b98548cfb439.svg";
export { ForwardRef as ReactComponent };